import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Contact from '../contact/Contact';
import ContactModal from '../contactModal/ContactModal';
import { getString } from '../../utils/languageUtils';
import { ReactComponent as Logo } from '../../assets/main_logo.svg';
import './Header.css';
import { throttle } from '../../utils/utilFunctions';
import { isMobile } from '../../utils/appUtils';
import { CiMenuBurger } from "react-icons/ci";
import { VscChromeClose } from "react-icons/vsc";
import LanguageSelector from '../languageSelector/LanguageSelector';

type HeaderProps = {
  onLogoClick: () => void;
  resetActiveProduct: () => void;
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  headerRef?: React.RefObject<HTMLDivElement>
};

const Header: React.FC<HeaderProps> = ({
  onLogoClick,
  resetActiveProduct,
  isMobileMenuOpen,
  toggleMobileMenu,
  headerRef
}) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleLogoClick = () => {
    onLogoClick();
    resetActiveProduct();
  };

  useEffect(() => {
    let lastScrollTop = 0;
    const headerWrapperEl: HTMLElement | null = document.querySelector('.desktop-header-wrapper');

    const handleScroll = throttle(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ((scrollTop > lastScrollTop) && headerWrapperEl) {
        // Scrolling down
        headerWrapperEl.classList.add('scroll-down');
        headerWrapperEl.classList.remove('scroll-up');
      } else if (headerWrapperEl) {
        // Scrolling up
        headerWrapperEl.classList.add('scroll-up');
        headerWrapperEl.classList.remove('scroll-down');
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }, 200);

    !isMobile() && window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  });

  return (
    <>
      <header className="header" ref={headerRef}>
        {isMobile() ? (
          // Mobile template
          <div className="header-content mobile">
            <div className="mobile-icons">
              {isMobileMenuOpen ? (
                <VscChromeClose className="close-icon" onClick={toggleMobileMenu} />
              ) : (
                <CiMenuBurger className="hamburger-icon" onClick={toggleMobileMenu} />
              )}
            </div>
            <div className="logo-container">
              <Link to="/" className="logo-link" onClick={handleLogoClick}>
                <img src="/logo_with_small_star.png" alt="Logo" className="logo" />
              </Link>
            </div>
            <div className="mobile-right">
              <LanguageSelector />
            </div>
          </div>
        ) : (
          // Desktop template
          <div className="header-content desktop">
            <div className="header-left">
            </div>
            <div className="logo-container">
              <Link to="/" className="logo-link" onClick={handleLogoClick}>
                <img style={{ width: '150px' }} src="/logo_with_small_star.png" alt="Logo" className="logo" />
              </Link>
            </div>
            <div className="header-right flex items-center gap-4">
              {/* <Search label="Search" /> */}
              <div onClick={() => setIsContactModalOpen(false)} className="cursor-pointer hidden">
                <Contact label="Contact" />
              </div>
              <LanguageSelector />
            </div>
          </div>
        )}
      </header>
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </>
  );
};

export default Header;